import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import handleRequestError from '../../utils/handleRequestError';

const initialState = {
    isLoading: true,
    vehicles: [],
    vehicleById: {},
    vehicleOperations: [],
    error: '',
};

export const fetchFTVehicles = createAsyncThunk(
    'ftVehicles/fetchFTVehicles',
    async (params, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOST_API_KEY}/machine`, { params });
            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

export const fetchFTVehicleById = createAsyncThunk(
    'ftVehicles/fetchFTVehicleById',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOST_API_KEY}/machine/${id}`);
            return response.data.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

export const fetchFTVehicleOperations = createAsyncThunk(
    'ftVehicles/fetchFTVehicleOperations',
    async (machineid, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOST_API_KEY}/fueltankoperation`, {
                params: { machineid },
            });
            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

export const createFTVehicle = createAsyncThunk(
    'ftVehicles/createFTVehicle',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_HOST_API_KEY}/machine`, data);
            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

export const updateFTVehicle = createAsyncThunk(
    'ftVehicles/updateFTVehicle',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${process.env.REACT_APP_HOST_API_KEY}/machine`, data);
            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

export const deleteFTVehicle = createAsyncThunk(
    'ftVehicles/deleteFTVehicle',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.delete(`${process.env.REACT_APP_HOST_API_KEY}/machine`, { data });
            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

const ftVehiclesSlice = createSlice({
    name: 'ftVehiclesSlice',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchFTVehicles.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchFTVehicles.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            state.error = '';
            state.vehicles = payload.data;
        });
        builder.addCase(fetchFTVehicles.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
        builder.addCase(fetchFTVehicleById.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchFTVehicleById.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            state.error = '';
            state.vehicleById = payload;
        });
        builder.addCase(fetchFTVehicleById.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
        builder.addCase(fetchFTVehicleOperations.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchFTVehicleOperations.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            state.error = '';
            state.vehicleOperations = payload.data;
        });
        builder.addCase(fetchFTVehicleOperations.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
        builder.addCase(createFTVehicle.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(createFTVehicle.fulfilled, (state) => {
            state.isLoading = false;
            state.error = '';
        });
        builder.addCase(createFTVehicle.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
        builder.addCase(updateFTVehicle.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(updateFTVehicle.fulfilled, (state) => {
            state.isLoading = false;
            state.error = '';
        });
        builder.addCase(updateFTVehicle.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
        builder.addCase(deleteFTVehicle.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(deleteFTVehicle.fulfilled, (state) => {
            state.isLoading = false;
            state.error = '';
        });
        builder.addCase(deleteFTVehicle.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
    },
});

export default ftVehiclesSlice.reducer;

export const selectFTVehiclesData = (state) => state.ftVehicles.vehicles;
export const selectFTVehicleById = (state) => state.ftVehicles.vehicleById;
export const selectFTVehicleOperations = (state) => state.ftVehicles.vehicleOperations;
export const selectFTVehiclesLoading = (state) => state.ftVehicles.isLoading;
export const selectFTVehiclesError = (state) => state.ftVehicles.error;
